<template>
  <div class="opc-succezz-layout" :class="{ 'is-furikomi': isApmFurikomi }" role="main">
    <div class="opc-succezz-layout__top__inner" :class="{ 'is-furikomi': isApmFurikomi }">
      <slot />
    </div>
    <div class="opc-succezz-layout__order-details" :class="{ 'is-furikomi': isApmFurikomi }" v-show="showDetails">
      <slot name="details" />
    </div>
    <div class="opc-succezz-layout__bottom" v-show="false">
      <div class="opc-succezz-layout__bottom__inner">
        <slot name="promotes" />
      </div>
    </div>
  </div>
</template>

<script>
import '@/styles/modal-iframe-override.scss';
import { isEmptyVal } from '@/utils';
import { APM_PAYMENT_METHODS } from '@/common/constants';
import {
  showModalDialogCloseButton,
  modalHybrid,
  watchThemeChange,
  closeiFrameContainerLoading,
  MODAL_CHECKOUT_MESSAGE_HOOK_MAP,
} from '@/utils/modal-utils.js';
import { logger } from "@/utils/log";
// cross-origin support
import { shouldUseCrossOrigin, CrossOriginBridge } from '@/utils/crossOriginHelper';

export default {
  created() {
    if (modalHybrid.isInWebview) {
      watchThemeChange();
    }
  },
  mounted() {
    document.body.classList.add('opc-succezz__body', 'opc-modal');
    if (this.isApmFurikomi) {
      const opcSuccess = document.querySelector('.opc-succezz__no__promotes')
      if (opcSuccess) {
        opcSuccess.style.paddingBottom = '0px';
        opcSuccess.style.justifyContent = 'stretch';
      }
      window.top.addEventListener('message', this.furikomiCloseModalMessageCallback);
    }
    closeiFrameContainerLoading();
    showModalDialogCloseButton();
  },
  beforeDestory() {
    if (this.isApmFurikomi) {
      window.top.removeEventListener('message', this.furikomiCloseModalMessageCallback);
    }
  },
  computed: {
    isApmFurikomi() {
      return !isEmptyVal(this.$config('apmMethodName')) && this.$config('apmMethodName') === APM_PAYMENT_METHODS.FURIKOMI
    },
    showDetails() {
      return this.isApmFurikomi
    }
  },
  methods: {
    furikomiCloseModalMessageCallback(event) {
      if (event?.data?.type === MODAL_CHECKOUT_MESSAGE_HOOK_MAP.sendClose && this.$config('skipSuccessPage')) {
        logger.log('refesh parent page on furikomi modal close when skipSuccessPage is true');
        // cross-origin support
        if (!shouldUseCrossOrigin()) {
          // Same-origin or non-embedded mode, use original logic
          window.top.location.reload();
        } else {
          // Cross-origin mode, use safe communication
          CrossOriginBridge.send(MODAL_CHECKOUT_MESSAGE_HOOK_MAP.reloadParent);
        }
      }
    }
  }
};
</script>

<style lang='scss'>
@import './style/header.scss';
</style>

<style lang='scss' scoped>
@import '@/styles/_variables.scss';

.opc-succezz-layout {
  padding: $mobile-space;

  &.is-furikomi {
    overflow: scroll;
    width: 100%;
  }

  &__top {
    background: #fff;

    &__inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      padding: 64px;

      &.is-furikomi {
        position: unset;
        transform: unset;
        padding: 30px 64px;
      }
    }
  }

  &__order-details {
    &.is-furikomi {
      padding: 0 64px 64px;
    }
  }

  &__bottom {
    &__inner {
      margin: 0 auto;
    }
  }
}
</style>
